import { EventEmitter } from 'events';

export default class BaseStore extends EventEmitter {
	constructor (dispatcher) {
		super();
		this.context = dispatcher;
		if(this.initialize) {
			this.initialize();
		}
    }
}